<template lang="html">
  <div class="subBlock">
      <slot></slot>
      <div :class="['subItems',stateClass,labelType]">
           <div :class="['sub-label',labelType]"></div>
           <div class="sub-content">
               <div class="sub-item"  v-for="(item,inx) in itemArrs" :key="inx" @click="itemTap(inx)" >
                   <div v-if="ipHide?inx<7:true">
                       {{item}}
                   </div>

               </div>
           </div>
      </div>
  </div>
</template>

<script>
export default {
    props:['itemArrs','subkey','labelType'],
    data(){
        return{
              stateClass:'',
              tempId:'',
              ipHide:''
        }
    },
    methods:{
        show:function(){
           this.stateClass = 'show';
        },
        hide:function(){
            this.stateClass = '';
        },
        itemTap:function(inx){
            this.$emit('itemSelect',{
                inx:inx,
                key:this.subkey
            });
            this.hide();
        }
    },
    mounted:function(){
        document.addEventListener('click',(e)=>{
             if(!this.$el.contains(e.target)){
                 this.hide();
             }
        });
        if(this.itemArrs.length == 8 && !this.$store.state.user.lgtype == 'ip'){
            this.ipHide = true;
        }
    }
}
</script>

<style lang="css" scoped>

.subBlock{
    position: relative;
}

.subItems{
    width: 90px;
    position: absolute;
    top: 50px;
    left: 0px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.65);
    display: none;
}

.subItems.right{
    margin-top: 12px;
    left: -60px;
}

.subItems.seek{
  margin-top: -5px;
  left: -52px;
}

.subItems.show{
    display: block;
    animation-name: show;
    animation-duration: 0.2s;
}

@keyframes show {
    from{
        opacity: 0;
        top: 60px;
    }
    to{
        opacity: 1;
        top: 50px;
    }
}

.subItems .sub-label{
    position: absolute;
    width:0;
    height:0;
    border-left:6px solid transparent;
    border-right:6px solid transparent;
    border-bottom:9px solid rgba(0, 0, 0, 0.65);

}

.subItems .sub-item{
   height: 36px;
   display: flex;
   color: white;
   align-items: center;
   justify-content: space-around;
   border-bottom: 1px solid #a3a3a3;
   margin: 0 6px;
   font-size: 13px;
}

.subItems .sub-item:last-child{
   border-bottom: none;
}

.subItems .sub-label{
   top: -9px;
}

.sub-label.middle{
    left: 39px;
}

.sub-label.right,
.sub-label.seek{
    left: 68px;
}

</style>
